import { render, staticRenderFns } from "./datasubject-boxes.vue?vue&type=template&id=5a82c766&scoped=true"
import script from "./datasubject-boxes.vue?vue&type=script&lang=js"
export * from "./datasubject-boxes.vue?vue&type=script&lang=js"
import style0 from "./datasubject-boxes.vue?vue&type=style&index=0&id=5a82c766&prod&lang=scss&scoped=true"
import style1 from "./datasubject-boxes.vue?vue&type=style&index=1&id=5a82c766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82c766",
  null
  
)

export default component.exports